module.exports = __webpack_public_path__ + "static/media/1_A1_15.d9918a0a.png";